const ShipDocumentReducer = (state = {}, action) => {
    switch (action.type) {
      case "SHIP_DOCS":
        return Object.assign({}, state, {
          shipdocnames: action.data,
        });
      case "UPLOAD_DOCS":
        return Object.assign({}, state, {
          uploaddocs: action.data,
        });
        case "HIDE_SHIPDEL":
        return Object.assign({}, state, {
          hideship: action.data,
        });
        case "SAVE_SHIPDOC":
        return Object.assign({}, state, {
          saveship: action.data,
        });
        default:
      return state;
  }
};

export default ShipDocumentReducer;